import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchOtherSettings,
  selectOtherSettings,
  setDataSuccess
} from 'src/features/staticDataSlice';
import OthersCreateModal from 'src/pages/OthersSettings/OthersCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function OtherMasterList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [othersCreatePermission, setOthersCreatePermission] = useState(false);

  const otherSettingsData = useSelector(selectOtherSettings);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setOthersCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('others', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchOtherSettings(productId).then((data) =>
      dispatch(setDataSuccess({ dataType: 'othersSettings', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Add validation logic if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-others" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-others"
          id="select-others"
          value={tableListDatas[index]?.others || ''}
          onChange={(event) => {
            handleChange('others', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {otherSettingsData?.map((other) => (
            <MenuItem key={other?.name} value={other?.name}>
              {other?.name}
            </MenuItem>
          ))}
          <Tooltip
            title={
              othersCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Risk Factor
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (othersCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: othersCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <OthersCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default OtherMasterList;
